import { useEffect, useState } from 'react'
import getPartner from '../repository/getPartner'
import { PartnerGeneralInfo } from '../types/PartnerGeneralInfo'

const fetchData = async () => {
  const { contact_info: contactInfo, error } = await getPartner()

  if (error) {
    throw new Error(error)
  }
  return {
    primaryContact: contactInfo.email,
    phoneNumber: contactInfo.phone_number,
    supportContactStackCommerce: contactInfo.support_contact_stacksocial,
    supportContactCustomers: contactInfo.support_contact_customers,
    supportFormUrl: contactInfo.support_form_url,
    fulfillmentContact: contactInfo.shipping_email_recipients,
    fulfillmentPhoneNumber: contactInfo.phone_number,
    address1: contactInfo.address_1,
    address2: contactInfo.address_2,
    city: contactInfo.city,
    state: contactInfo.state,
    zipcode: contactInfo.zip,
    country: contactInfo.country,
    addressVerificationState: contactInfo.address_verification_state
  }
}

export const useCurrentPartnerInfo = () => {
  const [partner, setPartner] = useState<PartnerGeneralInfo | null>(null)
  const [status, setStatus] = useState<'loading' | 'error' | 'success'>()
  const [error, setError] = useState()

  useEffect(() => {
    if (status === undefined) {
      setStatus('loading')
      fetchData()
        .then((data) => {
          setPartner(data)
          setStatus('success')
        })
        .catch((error) => {
          setStatus('error')
          setError(error)
        })
    }
  }, [status])

  return { status, partner, error }
}
